import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import axios from 'axios';
// Pages
import BrandSelect from "./pages/BrandSelect";
import Login from "./pages/Login";
import AgroDashboard from "./pages/Agro/AgroDashboard";
import ProductViewPage from './pages/Agro/ProductViewpage';
import WishlistPage from "./pages/Agro/WishlistPage";
import CartPage from "./pages/Agro/CartPage";
import SellerPortal from "./pages/Agro/sellerportal/sellerportal";
import ResellerPortal from "./pages/Agro/ResellerPortal/ResellerPortal"; 
import CheckoutPage from "./pages/Agro/CheckoutPage";
import AllCategories from "./pages/Agro/AllCategories";
import CategoryProducts from "./pages/Agro/CategoryProducts";
import OrderSuccess from './pages/Agro/Login/OrderSuccess';
import SellerAddProduct from "./pages/Agro/sellerportal/AddProducts";
import PublicSellerStore from './pages/Agro/sellerportal/PublicSellerStore';
import TermsAndConditions from './pages/Agro/Terms&conditions';
import RefundPolicy from './pages/Agro/RefundPolicy';
import Shippingpolicy from './pages/Agro/Shippingpolicy';
import PrivacyPolicy from './pages/Agro/PrivacyPolicy';
import SellerDeals from "./pages/Agro/sellerportal/SellerDeals";


import DivisionDashboard from "./pages/Agro/DivisionDashboard";
import AgroFreshDashboard from './pages/Agro/AgroFreshDashboard';
import AgroProductsDashboard from "./pages/Agro/AgroProductsDashboard";
import AgroValueAddedDashboard from "./pages/Agro/AgroValueAddedDashboard";


// agro hub

import HubDashboard from './pages/Agro/Hub/HubDashboard';
import HubLogin from './pages/Agro/Hub/HubLogin';
import HubOrders from './pages/Agro/Hub/HubOrders';

// Auth
import AuthModal from './pages/Agro/Login/AuthModal';
import MartAuthModal from './pages/Mart/Login/MartAuthModal';   // Dedicated Premium Mart Modal
import AboutPage from "./pages/Agro/AboutPage";


//imports for mart
import MartHome from "./pages/Mart/MartHome";
import MartSubCategories from './pages/Mart/MartSubCategories'; 
import MartProductDetail from './pages/Mart/MartProductDetail';
import MartSellerRoot from './pages/Mart/MartSeller/MartSellerRoot';
import MartCategories from './pages/Mart/MartCategories';
import MartAllProducts from './pages/Mart/MartAllProducts';

//admin imports

import AdminLogin from './pages/Agro/Admin/AdminLogin';
import AdminDashboard from './pages/Agro/Admin/AdminDashboard';

// ──────────────────────────────────────────────────────────────
// SEPARATE LIVE GODADDY ENDPOINTS FOR AGRO AND MART
// ──────────────────────────────────────────────────────────────
const AGRO_BASE = 'https://agro.atrmart.in/api'; // Modified: Points directly to your agro subdomain
const MART_BASE = 'https://api.atrmart.in/martapi';  // Modified: Points directly to your new mart subdomain


// --- CART & WISHLIST HELPERS ---
const loadCart = () => { try { return JSON.parse(localStorage.getItem('atr_cart') || '[]'); } catch { return []; } };
const loadWishlist = () => { try { return JSON.parse(localStorage.getItem('atr_wishlist') || '[]'); } catch { return []; } };


//token check of the admin

const PrivateRoute = ({ children }) => {
  return localStorage.getItem('admin_token') ? children : <Navigate to="/admin/login" />;
};


function App() {
  const [user, setUser] = useState(() => { 
    try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; } 
  });

  // --- FIXED: ADDED SEPARATE STATE TOGGLES TO PREVENT RUNTIME ERROR ---
  const [showAuth, setShowAuth] = useState(false);
  const [showMartAuth, setShowMartAuth] = React.useState(false);

  const [authHint, setAuthHint] = useState('');
  const [products, setProducts] = useState([]);
  const [authContext, setAuthContext] = useState('agro'); 
  const [categories, setCategories] = useState([{ name: 'All', icon: '🏡', color: '#2d6a4f' }]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState(loadCart);
  const [wishlist, setWishlist] = useState(loadWishlist);

  // --- CALCULATIONS ---
  const subtotal = cart.reduce((acc, item) => {
    const price = Number(item.price) || 0;
    const qty = Number(item.quantity) || 0;
    return acc + (price * qty);
  }, 0);

  // --- AUTH HANDLERS ---
  const handleAuthSuccess = useCallback((userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    const token = userData.token || userData.access_token;
    if (token) localStorage.setItem('user_token', token);
    setShowAuth(false);
    setShowMartAuth(false); // Close mart modal on success too
  }, []);

  const handleLogout = useCallback(() => {
    setUser(null); 
    localStorage.clear(); 
    setCart([]); 
    setWishlist([]);
  }, []);

  const requireAuth = useCallback((hint = 'Please login to continue') => {
    if (!user) {
      setAuthHint(hint);
      if (authContext === 'mart') {
        setShowMartAuth(true);
      } else {
        setShowAuth(true);
      }
      return false;
    }
    return true;
  }, [user, authContext]);

  // --- PERSISTENCE ---
  useEffect(() => {
    localStorage.setItem('atr_cart', JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem('atr_wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  // Sync Agro Cart Server
  useEffect(() => {
    const syncCartWithServer = async () => {
        const token = localStorage.getItem('user_token');
        if (user && token) {
            try {
                const response = await axios.get(`${AGRO_BASE}/api/cart`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (response.data.status) {
                    setCart(response.data.data);
                }
            } catch (err) {
                console.error("❌ Could not sync cart from database:", err);
            }
        }
    };
    syncCartWithServer();
  }, [user]); 

  // Fetch Agro Global Data
  useEffect(() => {
    const fetchGlobalData = async () => {
      try {
        const [pRes, cRes] = await Promise.all([
          axios.get(`${AGRO_BASE}/products`),
          axios.get(`${AGRO_BASE}/categories`)
        ]);
        setProducts(pRes.data?.data || pRes.data || []);
        const backendCats = cRes.data?.data || cRes.data || [];
        setCategories([{ name: 'All', icon: '🏡', color: '#2d6a4f' }, ...backendCats]);
      } catch (err) {
        console.error('❌ Fetch Error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchGlobalData();
  }, []);

  // --- CART OPERATIONS ---
  const addToCart = (newProd) => {
    setCart(prev => {
      const idx = prev.findIndex(i => i.id === newProd.id && i.selectedWeight === newProd.selectedWeight);
      if (idx >= 0) {
        const up = [...prev];
        up[idx].quantity += 1;
        return up;
      }
      return [...prev, { ...newProd, quantity: 1 }];
    });
  };

  const updateQuantity = (id, weight, qty) => {
    setCart(prev => qty <= 0 
      ? prev.filter(i => !(i.id === id && i.selectedWeight === weight))
      : prev.map(i => (i.id === id && i.selectedWeight === weight) ? { ...i, quantity: qty } : i)
    );
  };

  const removeFromCart = useCallback((id, weight) => {
    setCart(prev => prev.filter(item => !(item.id === id && item.selectedWeight === weight)));
  }, []);

  // --- WISHLIST OPERATIONS ---
  const toggleWishlist = async (product) => {
    if (!requireAuth()) return;
    const token = localStorage.getItem('user_token');
    
    setWishlist(prev => {
      const exists = prev.some(i => i.id === product.id);
      return exists ? prev.filter(i => i.id !== product.id) : [...prev, product];
    });

    try {
      await axios.post(`${AGRO_BASE}/api/wishlist/toggle`, { product_id: product.id }, {
        headers: { Authorization: `Bearer ${token}` }
      });                                                      
    } catch (e) { 
        console.error("Wishlist sync error:", e); 
    }
  };

  // Main global handler when shared components use onLoginClick
  const triggerLoginModal = () => {
    if (authContext === 'mart') {
      setShowMartAuth(true);
    } else {
      setShowAuth(true);
    }
  };

  const sharedProps = {
    cart, addToCart, updateQuantity, wishlist, toggleWishlist,
    user, onLoginClick: triggerLoginModal, onLogout: handleLogout,
    requireAuth, categories, products, removeFromCart
  };

  return (
    <Router>

      <AuthModal 
        isOpen={showAuth} 
        onClose={() => setShowAuth(false)} 
        onAuthSuccess={handleAuthSuccess} 
        hint={authHint} 
      />

      {/* Isolated Premium Mart Auth Modal Component View instance */}
      <MartAuthModal 
        isOpen={showMartAuth}
        onClose={() => setShowMartAuth(false)}
        onAuthSuccess={handleAuthSuccess}
        hint={authHint}
      />
    <Routes>

        {/* Admin Login Route */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Protected Admin Dashboard Route */}
        <Route path="/admin/dashboard" element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        } />
      
        
        {/* MART ROUTES */}

        <Route
  path="/mart-all-products"
  element={
    <MartAllProducts
      cart={cart}
      addToCart={addToCart}
      user={user}
      wishlist={wishlist}
      toggleWishlist={toggleWishlist}
      removeFromCart={removeFromCart}
    />
  }
/>



        <Route 
          path="/mart" 
          element={
            <MartHome 
              {...sharedProps} 
              martApiBase={MART_BASE} 
              onLoginClick={() => {
                setAuthContext('mart'); // Sets identity context window to Mart
                setAuthHint('Please sign-in to access premium Mart features');
                setShowMartAuth(true); 
              }}
            />
          } 
        />


        <Route path="/martcategories" element={<MartSubCategories />} />
        <Route path="/mart/product/:id" element={<MartProductDetail />} />
        <Route path="/martseller" element={<MartSellerRoot />} />
        <Route path="/martproducts" element={<MartCategories />} />

        {/* AGRO ROUTES */}
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/refundpolicy" element={<RefundPolicy />} />
        <Route path="/shippingpolicy" element={<Shippingpolicy />} />
        <Route path="/" element={<BrandSelect />} />
        <Route path="/login" element={<Login user={user} />} />
        <Route path="/add-product" element={<SellerAddProduct />} />
        <Route path="/seller" element={<SellerPortal />} />
        <Route path="/reseller" element={<ResellerPortal />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/store/:sellerId" element={<PublicSellerStore />} />
        <Route path="/seller/deals" element={<SellerDeals />} />
        <Route 
          path="/agro"  
          element={
            <AgroDashboard 
              {...sharedProps} 
              onLoginClick={() => {
                setAuthContext('agro'); 
                setAuthHint('Welcome to ATR Agro Mart');
                setShowAuth(true);
              }}
            />
          } 
        />

<Route 
  path="/division/:divisionId" 
  element={<DivisionDashboard AGRO_BASE={AGRO_BASE} {...sharedProps} />} 
/>

<Route path="/agro-fresh" element={<AgroFreshDashboard {...sharedProps} />} />
<Route path="/agro-products" element={<AgroProductsDashboard {...sharedProps} />} />
<Route path="/agro-value-added" element={<AgroValueAddedDashboard {...sharedProps} />} />


        <Route path="/categories" element={<AllCategories categories={categories} />} />
        <Route path="/category/:catName" element={<CategoryProducts {...sharedProps} />} />
        <Route path="/wishlist" element={<WishlistPage {...sharedProps} wishlistItems={wishlist} />} />
        <Route 
          path="/cart" 
          element={user ? <CartPage {...sharedProps} cartItems={cart} /> : <Navigate to="/agro" />} 
        />
        <Route path="/product/:id" element={<ProductViewPage {...sharedProps} />} />
        <Route 
          path="/checkout" 
          element={user ? <CheckoutPage {...sharedProps} cartItems={cart} subtotal={subtotal} /> : <Navigate to="/agro" />} 
        />


        <Route path="/hub/login" element={<HubLogin />} />
<Route path="/hub/dashboard" element={<HubDashboard />} />
<Route path="/hub/orders" element={<HubOrders />} />


      </Routes>
    </Router>
  );
}

export default App;